import { getReferrerOrigin } from '../query-params/getReferrerOrigin';
import { getWidgetShellUUID } from '../query-params/getWidgetShellUUID';
import { isDetachedWindow } from '../query-params/isDetachedWindow';
let _narrowTargetOriginEnabled = false;

// Called once from bootstrapWidget when LiveChat:NarrowPostMessageTargetOrigin is on.
export const enableNarrowTargetOrigin = () => {
  _narrowTargetOriginEnabled = true;
};

// For test isolation only — resets the module-level flag between test runs.
export const resetNarrowTargetOrigin = () => {
  _narrowTargetOriginEnabled = false;
};
export const getPostMessageTarget = () => {
  var _ref, _window$opener$parent, _window$opener;
  return isDetachedWindow() ? (_ref = (_window$opener$parent = (_window$opener = window.opener) === null || _window$opener === void 0 ? void 0 : _window$opener.parent) !== null && _window$opener$parent !== void 0 ? _window$opener$parent : window.opener) !== null && _ref !== void 0 ? _ref : window.parent : window.parent;
};
export const postMessageToParent = (type, data) => {
  try {
    var _getReferrerOrigin;
    const uuid = getWidgetShellUUID();
    const target = getPostMessageTarget();
    // Only narrow targetOrigin when the gate is on. In the detached popup path the target is
    // window.opener.parent (the embedding page) but document.referrer identifies the opener —
    // a different window, potentially cross-origin — so we always use '*' there.
    // For normal iframes, document.referrer reliably identifies the embedding page; we use it
    // as targetOrigin to avoid leaking widget state cross-origin. Falls back to '*' for the
    // ~65-75% of sessions without a referrer (see LiveChatProject#470).
    const targetOrigin = _narrowTargetOriginEnabled && !isDetachedWindow() ? (_getReferrerOrigin = getReferrerOrigin()) !== null && _getReferrerOrigin !== void 0 ? _getReferrerOrigin : '*' : '*';
    target.postMessage(JSON.stringify({
      type,
      data,
      uuid
    }), targetOrigin);
    return {
      type,
      data
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Error posting message to parent', e);
  }
};